<template>
  <v-row no-gutters>
    <v-col cols="4">
      <v-container class="px-8 fill-height">
        <v-row class="fill-height" align="stretch">
          <v-col cols="12">
            <v-row>
              <v-col cols="5">
                <v-img src="@/assets/logo-blue.svg" />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row justify="center">
              <v-col cols="8">
                <v-row>
                  <v-col>
                    <h2>
                      Trocar senha
                    </h2>
                  </v-col>
                </v-row>

                <v-form @submit.prevent="changePassword">
                  <v-row dense v-if="error">
                    <v-col>
                      <v-alert dense border="left" text type="error" class="text-subtitle-1">
                        {{ error }}
                      </v-alert>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="password"
                        label="Senha"
                        type="password"
                        hide-details
                        outlined
                        dense
                        placeholder=" "
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="passwordConfirmation"
                        label="Confirmação de senha"
                        type="password"
                        hide-details
                        outlined
                        dense
                        placeholder=" "
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-btn color="primary" block type="subimit">Trocar senha</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row justify="center" align="end" class="fill-height">
              <v-col cols="auto">
                <v-row no-gutters justify="center">
                  <v-col cols="auto" class="font-weight-bold text-caption">
                    EagleSoft v.1
                  </v-col>
                </v-row>

                <v-row no-gutters justify="center">
                  <v-col cols="auto" class="font-weight-bold secondary2--text text-caption">
                    Donato Hospital de Olhos
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-col>

    <v-col class="login-bg pr-5">
      <!-- <v-row align="end" justify="end" class="fill-height">
        <v-col cols="9" class="">
          <v-img src="@/assets/login-backgroud.svg" />
        </v-col>
      </v-row> -->
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "ChangePassword",
    props: {
      token: String,
    },
    data() {
      return {
        password: "",
        passwordConfirmation: "",
        error: "",
      };
    },
    methods: {
      changePassword() {
        this.error = "";

        if (this.password !== this.passwordConfirmation) {
          this.error = "As senha e confirmação de senha precisam ser iguais";
          return;
        }

        this.$axios
          .put(`${process.env.VUE_APP_BASE_URL}/users/password`, {
            user: {
              reset_password_token: this.token,
              password: this.password,
              password_confirmation: this.passwordConfirmation,
            },
          })
          .then(() => {
            this.$store.dispatch("createNotification", {
              message: "Senha alterada com sucesso.",
              type: "success",
            });

            this.$router.push("/login");
          })
          .catch((error) => {
            this.error = error.response.data.password.join(", ");
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .login-bg {
    height: 100vh;
    background: rgb(46, 86, 228);
    background: linear-gradient(45deg, rgba(46, 86, 228, 1) 0%, rgba(101, 219, 226, 1) 100%);
  }
</style>
